import { GUIDE_CHARACTER } from "@/assets/guide";

type GuideSize = "sm" | "md" | "lg";

type Props = {
  message: string;
  size?: GuideSize;
  /** キャラクターを吹き出しの左右どちらに置くか */
  character?: "left" | "right";
  className?: string;
};

const SIZE: Record<GuideSize, { img: string; gap: string; text: string; pad: string }> = {
  sm: { img: "w-14 h-14", gap: "gap-3", text: "text-[13px] leading-6", pad: "px-3.5 py-3" },
  md: { img: "w-20 h-20 sm:w-24 sm:h-24", gap: "gap-3.5 sm:gap-4", text: "text-sm leading-7", pad: "px-4 py-3.5" },
  lg: { img: "w-28 h-28 sm:w-32 sm:h-32", gap: "gap-4 sm:gap-5", text: "text-[15px] leading-8", pad: "px-5 py-4" },
};

export default function CharacterGuide({
  message,
  size = "md",
  character = "left",
  className = "",
}: Props) {
  const s = SIZE[size];

  const bubble = (
    <div
      className={`guide-bubble ${
        character === "left" ? "guide-bubble--left" : "guide-bubble--right"
      } flex-1 min-w-0 rounded-lg border border-accent-200 bg-accent-50 ${s.pad}`}
    >
      <p className={`${s.text} text-foreground-800`}>{message}</p>
    </div>
  );

  const figure = (
    <div
      className={`shrink-0 ${s.img} rounded-lg border border-background-200 bg-background-100 overflow-hidden flex items-end justify-center`}
    >
      <img
        src={GUIDE_CHARACTER.src}
        alt={GUIDE_CHARACTER.alt}
        width={GUIDE_CHARACTER.width}
        height={GUIDE_CHARACTER.height}
        className="w-full h-full object-contain object-bottom"
      />
    </div>
  );

  return (
    <div className={`flex items-center ${s.gap} ${className}`}>
      {character === "left" ? (
        <>
          {figure}
          {bubble}
        </>
      ) : (
        <>
          {bubble}
          {figure}
        </>
      )}
    </div>
  );
}